/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1bhr%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rjc1b66%7Bpadding-block%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1mok%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18zr1b66%7Bpadding-inline%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
import React, { useState } from 'react';
import DashboardIcon from '@atlaskit/icon/core/dashboard';
import HashTagIcon from '@atlaskit/icon/core/hashtag';
import MegaphoneIcon from '@atlaskit/icon/core/megaphone';
import SearchIcon from '@atlaskit/icon/core/search';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';
import TelescopeIcon from '@atlaskit/icon-lab/core/telescope';
import { Popup } from '@atlaskit/popup/popup';
import { Bleed } from '@atlaskit/primitives/compiled/bleed';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { ButtonMenuItem } from '@atlaskit/side-nav-items/button-menu-item';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { layers } from '@atlaskit/theme/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { RelayEnvironmentProvider } from 'react-relay';
import { AnalyticsSideNavItem, type AnalyticsSideNavItemType, useSendSideNavItemClick } from '@townsquare/analytics-nav4';
import { useUnitsEnabled } from '@townsquare/collab-context';
import { useDashboardExperienceStatus } from '@townsquare/dashboards-view/hooks/useDashboardExperienceStatus';
import { useDiscoverPath } from '@townsquare/discover-view/hooks/use-discover-path';
import { discoverRouteDefinition } from '@townsquare/discover-view/route-definitions';
import { type CommonSideNavItemProps, type BaseSideNavItemType } from '@townsquare/griffin-navigation/types';
import { SideNavProductItem } from '@townsquare/navigation-config/nav4';
import { useNoOrgExperience } from '@townsquare/org-context';
import { getRelayEnvironment } from '@townsquare/relay-utils/townsquare-environment';
import { useRouteDependencies } from '@townsquare/router/primitives/dependencies';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { generatePath } from '@townsquare/router/primitives/path';
import { useRouter } from '@townsquare/router/useRouter';
import { dashboardRoute } from '@townsquare/routes/dashboard';
import { dashboardByIdRoute } from '@townsquare/routes/dashboard-by-id';
import { dashboardDirectoryRoute } from '@townsquare/routes/dashboard-directory';
import { goalUpdateViewRoute } from '@townsquare/routes/goal-updates-view';
import { projectUpdateViewRoute } from '@townsquare/routes/project-updates-view';
import { rovoSearchRoute } from '@townsquare/routes/rovo-search-view';
import { savedViewsUpdatesRoute } from '@townsquare/routes/saved-views-updates-view';
import { searchRoute } from '@townsquare/routes/search';
import { tagFeedViewRoute } from '@townsquare/routes/tag-feed-view';
import { tagsDirectoryRoute } from '@townsquare/routes/tags-directory';
import { teamUpdatesViewRoute } from '@townsquare/routes/team-updates-view';
import { topicRoute } from '@townsquare/routes/topic-page';
import { starredRouteDefinition } from '@townsquare/starred-view/route-definitions';
import { fg } from '@townsquare/stat-sig/gate';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';
import { DashboardsSideNavItem } from '../DashboardsSideNavItem';
import { ExternalRedirectNavItem } from '../ExternalRedirectNavItem';
import { useStatusUpdatesPath } from '../use-status-updates-path';
import { useTagsDirectoryRoute } from '../use-tags-directory-route';
const styles = {
  container: "_kqswh2mm",
  padding: "_18zr1b66",
  menuGroup: "_2rko1mok _1rjc1b66 _18zr1b66 _bfhk1bhr _kqswh2mm"
};
export const RovoMoreMenu = (props: CommonSideNavItemProps): React.JSX.Element => {
  // Internal checks use useUserHasCapabilities, which must run against Townsquare Relay environment
  return <RelayEnvironmentProvider environment={getRelayEnvironment()}>
			<RovoMoreMenuInternal {...props} />
		</RelayEnvironmentProvider>;
};
const RovoMoreMenuInternal = (props: CommonSideNavItemProps) => {
  const {
    isSelected,
    onClick,
    item
  } = props;
  const noOrgExperience = useNoOrgExperience();
  const [routerStore] = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const {
    discoverPath,
    isDiscoverEnabled
  } = useDiscoverPath();
  const {
    statusUpdatesPath,
    isStatusUpdatesEnabled
  } = useStatusUpdatesPath();
  const {
    tagsDirectoryPath,
    isTagsDirectoryEnabled
  } = useTagsDirectoryRoute();
  const isSearchSelected = !!matchRoute([searchRoute, rovoSearchRoute], routerStore.location.pathname, undefined);
  const isStarredSelected = !!matchRoute([starredRouteDefinition], routerStore.location.pathname, undefined);
  const isDiscoverSelected = !!matchRoute([discoverRouteDefinition], routerStore.location.pathname, undefined);
  const isStatusUpdatesSelected = !!matchRoute([projectUpdateViewRoute, goalUpdateViewRoute, tagFeedViewRoute, savedViewsUpdatesRoute, teamUpdatesViewRoute], routerStore.location.pathname, undefined);
  const isTagsDirectorySelected = !!matchRoute([tagsDirectoryRoute, topicRoute], routerStore.location.pathname, undefined);
  const isDashboardsSelected = !!matchRoute([dashboardDirectoryRoute, dashboardRoute, dashboardByIdRoute], routerStore.location.pathname, undefined);
  const hasNoWorkspace = useNoWorkspaceExperience();
  const {
    isOptedIn: isDashboardOptedIn
  } = useDashboardExperienceStatus();
  const isDashboardsEnabled = !hasNoWorkspace && fg('atlas_enable_dashboard_route') && isDashboardOptedIn;
  const anyShown = [!isSearchSelected, !noOrgExperience && !isStarredSelected, isDiscoverEnabled && !isDiscoverSelected, isStatusUpdatesEnabled && !isStatusUpdatesSelected, isTagsDirectoryEnabled && !isTagsDirectorySelected, isDashboardsEnabled && !isDashboardsSelected].some(Boolean);
  if (!anyShown) {
    return null;
  }
  return <Bleed inline="space.050" xcss={styles.container}>
			<Popup isOpen={isOpen} onClose={() => setIsOpen(false)} placement="bottom-start" shouldRenderToParent shouldFitContainer zIndex={layers.dialog()} trigger={({
      ref,
      ...triggerProps
    }) => <Box xcss={styles.padding} ref={ref}>
						<ButtonMenuItem
      // Remaining triggerProps go to the button so we have appropriate aria controls
      {...triggerProps} elemBefore={<ShowMoreHorizontalIcon label="" color="currentColor" />} onClick={e => {
        onClick((item as BaseSideNavItemType), e);
        setIsOpen(!isOpen);
      }} isSelected={isOpen || isSelected}>
							<FormattedMessage id="townsquare.atlassian-home.side-nav.more" defaultMessage="More" description="More label" />
						</ButtonMenuItem>
					</Box>} content={() => <MoreMenuContent setIsOpen={setIsOpen} isStarredEnabled={!noOrgExperience && !isStarredSelected} isSearchEnabled={!isSearchSelected} discoverPath={discoverPath} isDiscoverEnabled={isDiscoverEnabled && !isDiscoverSelected} statusUpdatesPath={statusUpdatesPath} isStatusUpdatesEnabled={isStatusUpdatesEnabled && !isStatusUpdatesSelected} tagsDirectoryPath={tagsDirectoryPath} isTagsDirectoryEnabled={isTagsDirectoryEnabled && !isTagsDirectorySelected} isDashboardsEnabled={isDashboardsEnabled && !isDashboardsSelected} />} />
		</Bleed>;
};
type InnerProps = {
  setIsOpen: (isOpen: boolean) => void;
  isSearchEnabled: boolean;
  isStarredEnabled: boolean;
  discoverPath: string;
  isDiscoverEnabled: boolean;
  statusUpdatesPath: string;
  isStatusUpdatesEnabled: boolean;
  tagsDirectoryPath: string;
  isTagsDirectoryEnabled: boolean;
  isDashboardsEnabled: boolean;
};
const MoreMenuContent = ({
  isSearchEnabled,
  isStarredEnabled,
  discoverPath,
  isDiscoverEnabled,
  statusUpdatesPath,
  isStatusUpdatesEnabled,
  tagsDirectoryPath,
  isTagsDirectoryEnabled,
  isDashboardsEnabled,
  setIsOpen
}: InnerProps) => {
  const intl = useIntl();
  const [routerStore] = useRouter();
  const routeDependencies = useRouteDependencies();
  const unitsEnabled = useUnitsEnabled();
  const sendSideNavItemClick = useSendSideNavItemClick();
  const onClick = (item: AnalyticsSideNavItemType) => {
    setIsOpen(false);
    sendSideNavItemClick('navigationItem', item, {
      screen: routerStore.route.name
    });
  };
  return <Stack xcss={styles.menuGroup}>
			{isSearchEnabled && <LinkMenuItem href={generatePath(rovoSearchRoute, routeDependencies)} onClick={() => onClick(AnalyticsSideNavItem.SEARCH)} elemBefore={<SearchIcon label="" color="currentColor" />} testId="side-nav-search">
					<FormattedMessage id="townsquare.atlassian-home.side-nav.search" description="Side nav button to open search page" defaultMessage="Search" />
				</LinkMenuItem>}
			{isStarredEnabled && <LinkMenuItem href={generatePath(starredRouteDefinition, routeDependencies)} onClick={() => onClick(AnalyticsSideNavItem.STARRED)} elemBefore={<StarUnstarredIcon label="" color="currentColor" />} testId="side-nav-starred">
					<FormattedMessage id="townsquare.atlassian-home.side-nav.starred" description="Side nav button to open starred page" defaultMessage="Starred" />
				</LinkMenuItem>}
			{isDiscoverEnabled && <DiscoverItem onClick={() => onClick(AnalyticsSideNavItem.DISCOVER)} path={discoverPath} unitsMode={unitsEnabled} />}
			{isStatusUpdatesEnabled && <StatusUpdatesItem onClick={() => onClick(AnalyticsSideNavItem.UPDATES)} path={statusUpdatesPath} unitsMode={unitsEnabled} />}
			{isTagsDirectoryEnabled && <TagsDirectoryItem onClick={() => onClick(AnalyticsSideNavItem.TAGS)} path={tagsDirectoryPath} unitsMode={unitsEnabled} />}
			{isDashboardsEnabled && <DashboardsSideNavItem onClick={() => onClick(AnalyticsSideNavItem.DASHBOARDS)} item={{
      path: generatePath(dashboardDirectoryRoute, routeDependencies),
      matches: [dashboardDirectoryRoute, dashboardRoute, dashboardByIdRoute],
      name: intl.formatMessage({
        id: 'townsquare.atlassian-home.side-nav.dashboards',
        description: 'Side nav button to open dashboards',
        defaultMessage: 'Dashboards'
      }),
      analyticsSubject: AnalyticsSideNavItem.DASHBOARDS,
      id: SideNavProductItem.DASHBOARDS,
      Icon: DashboardIcon
    }} />}
		</Stack>;
};
type IndividualItemProps = {
  onClick: () => void;
  path: string;
  unitsMode: boolean;
};
const DiscoverItem = ({
  onClick,
  path,
  unitsMode
}: IndividualItemProps) => {
  const intl = useIntl();
  if (unitsMode) {
    return <ExternalRedirectNavItem onClick={onClick} item={{
      path,
      matches: [discoverRouteDefinition],
      name: intl.formatMessage({
        id: 'townsquare.atlassian-home.side-nav.discover',
        description: 'Side nav button to open discover page',
        defaultMessage: 'Discover'
      }),
      analyticsSubject: AnalyticsSideNavItem.DISCOVER,
      id: SideNavProductItem.DISCOVER,
      testId: 'side-nav-discover',
      Icon: TelescopeIcon
    }} />;
  }
  return <LinkMenuItem href={path} onClick={onClick} elemBefore={<TelescopeIcon label="" color="currentColor" />} testId="side-nav-discover">
			<FormattedMessage id="townsquare.atlassian-home.side-nav.discover" description="Side nav button to open discover page" defaultMessage="Discover" />
		</LinkMenuItem>;
};
const StatusUpdatesItem = ({
  onClick,
  path,
  unitsMode
}: IndividualItemProps) => {
  const intl = useIntl();
  if (unitsMode) {
    return <ExternalRedirectNavItem onClick={onClick} item={{
      path,
      matches: [projectUpdateViewRoute, goalUpdateViewRoute, tagFeedViewRoute, savedViewsUpdatesRoute, teamUpdatesViewRoute],
      name: intl.formatMessage({
        id: 'townsquare.home.rovo-more-menu.status-updates',
        description: 'Side nav button to open projects updates page',
        defaultMessage: 'Status updates'
      }),
      analyticsSubject: AnalyticsSideNavItem.UPDATES,
      id: SideNavProductItem.UPDATES,
      testId: 'side-nav-status-updates',
      Icon: MegaphoneIcon
    }} />;
  }
  return <LinkMenuItem href={path} onClick={onClick} elemBefore={<MegaphoneIcon label="" color="currentColor" />} testId="side-nav-status-updates">
			<FormattedMessage id="townsquare.atlassian-home.side-nav.status-updates" description="Side nav button to open projects updates page" defaultMessage="Status updates" />
		</LinkMenuItem>;
};
const TagsDirectoryItem = ({
  onClick,
  path,
  unitsMode
}: IndividualItemProps) => {
  const intl = useIntl();
  if (unitsMode) {
    return <ExternalRedirectNavItem onClick={onClick} item={{
      path,
      matches: [tagsDirectoryRoute, topicRoute],
      name: intl.formatMessage({
        id: 'townsquare.atlassian-home.side-nav.tags',
        description: 'Side nav button to open projects topics tags',
        defaultMessage: 'Tags'
      }),
      analyticsSubject: AnalyticsSideNavItem.TAGS,
      id: SideNavProductItem.TAGS,
      testId: 'side-nav-tags',
      Icon: HashTagIcon
    }} />;
  }
  return <LinkMenuItem href={path} onClick={onClick} elemBefore={<HashTagIcon label="" color="currentColor" />} testId="side-nav-tags">
			<FormattedMessage id="townsquare.atlassian-home.side-nav.tags" description="Side nav button to open projects topics tags" defaultMessage="Tags" />
		</LinkMenuItem>;
};